import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="block w-2 h-2 bg-blue-500 rounded-full"></span>
            <span className="font-display font-bold text-xl text-white">
              Open<span className="text-blue-500">Payments</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">{t("footer.product")}</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#productos" className="link-underline">{t("footer.iban_accounts")}</a></li>
            <li><a href="/#productos" className="link-underline">{t("footer.sepa_transfers")}</a></li>
            <li><a href="/#productos" className="link-underline">{t("footer.iban_validator")}</a></li>
            <li><Link to="/arquitectura-defi" className="link-underline">{t("nav.defi")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">{t("footer.legal")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terminos" className="link-underline">{t("footer.terms")}</Link></li>
            <li><Link to="/terminos#fca" className="link-underline">{t("footer.fca")}</Link></li>
            <li><Link to="/terminos#mica" className="link-underline">{t("footer.mica")}</Link></li>
            <li><Link to="/terminos#privacidad" className="link-underline">{t("footer.privacy")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">{t("footer.compliance")}</div>
          <div className="space-y-3 text-xs font-mono-fin text-slate-400 leading-relaxed">
            <div>FCA Ref. 9XX834 · UK</div>
            <div>MiCA · Reglamento (UE) 2023/1114</div>
            <div>BIC · OPPMESM1XXX</div>
            <div>ISO 20022 · PSD2 · GDPR</div>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} OpenPayments S.A. {t("footer.rights")}</div>
          <div className="mt-2 md:mt-0">{t("footer.made_in_europe")}</div>
        </div>
      </div>
    </footer>
  );
}
